import { BaseLoader } from '@/utils/rtk/base.loader';
import { relationshipCompaniesApi } from './relationshipCompaniesApi';

export class RelationshipCompanyLoader extends BaseLoader {
	detailLoader = async ({ params, request }) => {
		const relationshipCompany = await this._loader(
			relationshipCompaniesApi.endpoints.getRelationshipCompany,
			request,
			params.relationshipCompanyId,
		);
		return { relationshipCompany };
	};
}
